<template>
    <div class="speaker-card mb-sm">
        <div class="speaker-card__image"
             :class="{'speaker-card__image--no-image' : image == null }"
        >
            <div v-if="regionTitle" class="speaker-card__tag text--white semi small">
                <svg class="speaker-card__tag-icon icon">
                    <use xlink:href="#pin" />
                </svg>
                {{ regionTitle }}
            </div>
            <img v-if="image != null" :src="image" :alt="title">
            <div class="speaker-card__overlay">
                <a class="btn btn--ghost speaker-card__btn js-popup-open-speaker-bio" @click="openModal">Read more</a>
            </div>
        </div>
        <div class="speaker-card__content py-sm">
            <h5 v-if="title" class="speaker__title semi">{{ title }}</h5>
            <h6 class="small semi text--grey-dark">{{ position }}</h6>
            <div class="small text--grey-dark mb-sm">{{ organisation }}</div>
            <div class="speaker__expertise small">
                <p v-if="expertise.length > 3" class="text--orange small semi">{{ expertiseCount }}</p>
                <ul v-if="displayedexpertise.length > 0" class="speaker-card__list small text--grey">
                    <li v-for="(interest, key) in displayedexpertise" :key="key" class="speaker-card__list-item">
                        {{ interest }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../event-bus';

export default {
    props: {
        id: {
            type: String,
            default: null
        },
        slug: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        position: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        organisation: {
            type: String,
            default: null
        },
        modalImage: {
            type: String,
            default: null
        },
        summary: {
            type: String,
            default: null
        },
        regionTitle: {
            type: String,
            default: null
        },
        expertise: {
            type: Array,
            default: null
        },
        otherExpertise: {
            type: String,
            default: null
        },
        linkedin: {
            type: String,
            default: null
        },
        activeModelSearchTerm: {
            type: String,
            default: null
        },
    },
    data() {
        return {
        };
    },
    computed: {
        expertiseCount() {
            return `Expertise + ${this.expertise.length - 3}`;
        },
        displayedexpertise() {
            return this.expertise.slice(0, 3);
        },
    },
    methods: {
        openModal() {
            EventBus.$emit('speaker-modal',
                {
                'title': this.title,
                'position': this.position,
                'organisation': this.organisation,
                'modalImage': this.modalImage,
                'summary': this.summary,
                'regionTitle': this.regionTitle,
                'otherExpertise': this.otherExpertise,
                'expertise': this.expertise,
                'linkedin' : this.linkedin
                }
            );
        }
    },
}
    </script>